// @flow

import React from 'react';
import PropTypes from 'prop-types';

import { Avatar } from '@material-ui/core/';

import './style.css';

type Props = {
    className?: string,
    ...
};

function Image(props: Props) {
    const { className, ...additionalProps } = props;

    return (
        <Avatar
            {...additionalProps}
            variant="square"
            component="span"
            className={`app-img ${className ? className : ''}`}
        />
    );
}

Image.propTypes = {
    className: PropTypes.string
};

export default Image;
